import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityCardOrgChart: ExtensionDefinition = EntityCardBlueprint.make(
  {
    name: 'entity-user-org-card',
    params: {
      filter: { kind: 'User' },
      loader: async () => import('./org').then(m => <m.EntityOrgChartCard />),
    },
  },
);

export const entityCardTeam: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'entity-user-team-card',
  params: {
    filter: { kind: 'User' },
    loader: async () => import('./org').then(m => <m.EntityTeamCard />),
  },
});
